export default __webpack_public_path__ + "static/media/strategyImg3.877ef31d.jpg";